import { AnyAction } from 'redux';
import { Employee } from '@synergy/models';

import { CUSTOMER_TOPICS_CHANGE_EMPLOYEE_TOPICS, CUSTOMER_TOPICS_RECEIVED } from './customer-topics-actions';

export interface CustomerDetailTopicReducerState {
    employeeTopics: Employee[] | null;
}

export const initialCustomerDetailTopicReducerState: CustomerDetailTopicReducerState = {
    employeeTopics: null,
};

export const customerDetailTopicReducer = (
    state: CustomerDetailTopicReducerState = initialCustomerDetailTopicReducerState,
    action: AnyAction
): CustomerDetailTopicReducerState => {
    switch (action.type) {
        case CUSTOMER_TOPICS_RECEIVED: {
            return {
                ...state,
                employeeTopics: action['employees'],
            };
        }

        case CUSTOMER_TOPICS_CHANGE_EMPLOYEE_TOPICS: {
            const nextEmployees = [...(state.employeeTopics ?? [])];
            const index = nextEmployees.findIndex(employee => employee.id === action['employeeId']);
            if (index < 0) {
                return state;
            }

            nextEmployees[index].topics = action['topics'];
            return {
                ...state,
                employeeTopics: nextEmployees,
            };
        }

        default: {
            return state;
        }
    }
};
